<!--
  name : 박태희
  desc : 회원간편전환 메일 인증
  date : 2021-03-03
-->
<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" class="login_main_title">가입 인증 확인</v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center">
      <v-card
        id="popStyle02"
        class="popW800"
        v-if="this.isProgress === 'loading'"
      >
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            글로싸인엔터프라이즈 회원 전환 인증 화면 입니다.
          </div>
          <div class="popCon_txt">
            <span class="txtst_info_gray"
              >회원 전환 인증이 진행 중입니다. 잠시만 기다려 주세요.</span
            >
          </div>
        </v-card-text>
      </v-card>
      <v-card
        id="popStyle02"
        class="popW800"
        v-else-if="this.isProgress === 'done'"
      >
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            글로싸인엔터프라이즈 회원 전환 인증을 완료하였습니다.<br />글로싸인엔터프라이즈에
            로그인 하세요.
          </div>
          <div class="popCon_txt">
            <span class="txtst_info_gray"
              >본 페이지의 인증완료 후 비회원으로 수신받은 과거 전자계약은
              글로싸인엔터프라이즈에 접속하여 회원 로그인 후 확인하실 수
              있습니다.</span
            >
          </div>
        </v-card-text>
      </v-card>
      <v-card
        id="popStyle02"
        class="popW800"
        v-else-if="this.isProgress === 'already'"
      >
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            이미 인증된 가입인증 정보 입니다.<br />가입인증을 진행할수 없습니다.
          </div>
        </v-card-text>
      </v-card>
      <v-card id="popStyle02" class="popW800" v-else>
        <v-card-text class="signup-text02">
          <div class="popCon_txt row_mb-20">
            회원 전환 인증실패<br />다시 시도해주세요 (메일함의 링크를 다시
            선택하거나, 다시 인증을 신청하세요)
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>s
  </v-container>
</template>
<script>
import { isCheckAuthUser, changeUserAction } from "@/api/join";

export default {
  name: "",
  components: {},
  filters: {},
  data() {
    return {
      isProgress: "",
      checkUserInfo: {
        usr_sw_id: "",
        usr_email: "",
        usr_cn_adr: ""
      }
    };
  },
  created() {
    this.isProgress = "loading";
  },
  mounted() {
    this.checkUserInfo.usr_email = this.$route.query.email;
    this.checkUserInfo.usr_sw_id = this.$route.query.uuid;
    this.$nextTick(() => {
      this.check_user();
    });
  },
  methods: {
    check_user() {
      this.$refs.loading.start("인증 확인 중");
      isCheckAuthUser(
        JSON.stringify({
          usr_sw_id: this.checkUserInfo.usr_sw_id,
          usr_email: this.checkUserInfo.usr_email
        })
      ).then(Response => {
        if (Response.rdata.rcode === 20000) {
          this.checkUserInfo.usr_cn_adr = Response.rdata.usr_cn_adr;
          this.$refs.loading.end();
          this.update_SwJoinUserInfo();
        } else if (Response.rdata.rcode === 50001) {
          this.$refs.loading.end();
          this.isProgress = "already";
          this.$refs.confirm
            .open("alert", "회원 전환 인증", Response.rdata.message)
            .then(() => {
              this.$router.push({ name: "login" });
            });
        } else {
          this.$refs.loading.end();
          this.isProgress = "error";
          this.$refs.confirm.open(
            "alert",
            "회원 전환 인증",
            Response.rdata.message
          );
        }
      });
    },
    update_SwJoinUserInfo() {
      this.$refs.loading.start("인증 처리 중");
      changeUserAction(
        JSON.stringify({
          usr_sw_id: this.checkUserInfo.usr_sw_id,
          usr_email: this.checkUserInfo.usr_email,
          usr_cn_adr: this.checkUserInfo.usr_cn_adr
        })
      ).then(Response => {
        if (Response.rdata.rcode === 20000) {
          this.$refs.loading.end();
          this.isProgress = "done";
        } else {
          this.$refs.loading.end();
          this.isProgress = "error";
          this.cancelAlert(Response.rdata.message);
        }
      });
    }
  }
};
</script>
<style scoped></style>
